<template>
  <el-dialog title="详情"
             :visible.sync="showModal"
             @close="handleCancel"
             width="40%">
    <el-tabs v-model="activeName">
      <el-tab-pane v-if="true"
                   label="基本信息"
                   name="1">
        <el-card shadow="never">
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>编号：{{ actData.info.sn }}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>设备名称：{{ actData.info.name }}</p>
          <!-- <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>所属房间：{{ actData.info.room_name }}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>设备类型：{{ actData.info.dev_type }}</p> -->
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>设备版本：{{ actData.info.ver }}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>所属网关：{{ actData.info.gate_sn }}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>在线状态：{{ actData.info.online }}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>电量：{{ actData.info.electricity }}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>通道号：{{ actData.info.gate_channel }}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>通道地址：{{ actData.info.gate_addr }}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>频率：{{ actData.info.frequency }}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>空口速率：{{ actData.info.speed_rate }}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>注册时间：{{ actData.info.regtime }}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>备注：{{ actData.info.remarks }}</p>
        </el-card>
      </el-tab-pane>
      <el-tab-pane label="LORA参数"
                   v-if="false"
                   name="2">
        <el-card shadow="never">
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>频率：{{ actData.lora[0] ? actData.lora[0].Frequency : ''}}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>空中速率(kbps)：{{ actData.lora[0] ? actData.lora[0].SpeedRate : ''}}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>发射功率(dBm)：{{ actData.lora[0] ? actData.lora[0].RadioPower : ''}}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>串口速率(bps)：{{ actData.lora[0] ? actData.lora[0].ComSpeed: '' }}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>串口校验方式：{{ actData.lora[0] ? comCheckData[actData.lora[0].ComCheck] : ''}}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>唤醒周期(ms)：{{ actData.lora[0] ? actData.lora[0].AwakenTime: '' }}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>触发延时(ms)：{{ actData.lora[0] ? actData.lora[0].TriggerDelay : ''}}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>载波监听时间(ms)：{{ actData.lora[0] ? actData.lora[0].CarrierTime : ''}}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>无线数据包长(Byte)：{{ actData.lora[0] ? actData.lora[0].WirelessPkgLen : ''}}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>硬件地址：{{ actData.lora[0] ? actData.lora[0].DeviceAddr : ''}}</p>
          <!-- <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>目标地址：{{ actData.lora[0] ? actData.lora[0].TargetAddr : ''}}</p> -->
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>
            定长帧模式：{{ actData.lora[0] ? (actData.lora[0].FB_FixedFrame === '1' ? '是' : '否') : ''}}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>
            场强检测：{{ actData.lora[0] ? (actData.lora[0].FB_FieldStrength === '1' ? '是' : '否') : ''}}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>
            载波侦听：{{ actData.lora[0] ? (actData.lora[0].FB_CarrierSense === '1' ? '是' : '否') : ''}}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>
            硬件地址使能：{{ actData.lora[0] ? (actData.lora[0].FB_DevAddrEnable === '1' ? '是' : '否') : ''}}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>
            发送源地址使能：{{ actData.lora[0] ? (actData.lora[0].FB_SrcAddrEnable === '1' ? '是' : '否') : ''}}</p>
          <p class="card-text"><i class="el-icon-discount ftblue mr-10"></i>
            低功耗休眠：{{ actData.lora[0] ? (actData.lora[0].FB_LowPowerSleep === '1' ? '是' : '否') : ''}}</p>
        </el-card>
      </el-tab-pane>
    </el-tabs>
    <span slot="footer"
          class="dialog-footer">
      <el-button type="primary"
                 @click="handleCancel">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: String
    }
  },
  data() {
    return {
      showModal: this.isShow,
      activeName: '1',
      comCheckData: { '00': '无校验', '01': '奇校验', '02': '偶校验' },
      actData: {
        info: {
          activated: '',
          area_id: '',
          electricity: '',
          frequency: '',
          gate_addr: '',
          gate_channel: '',
          gate_sn: '',
          id: '',
          last_time: '',
          lock_med: '',
          lock_model: '',
          dev_type: '',
          name: '',
          online: '',
          regtime: '',
          remarks: '',
          room_name: '',
          sn: '',
          speed_rate: '',
          ver: ''
        },
        lora: [
          {
            AwakenTime: '',
            CarrierTime: '',
            ComCheck: '',
            ComSpeed: '',
            DeviceAddr: '',
            FB_CarrierSense: '',
            FB_DevAddrEnable: '',
            FB_FieldStrength: '',
            FB_FixedFrame: '',
            FB_LowPowerSleep: '',
            FB_SrcAddrEnable: '',
            Frequency: '',
            RadioPower: '',
            SpeedRate: '',
            TriggerDelay: '',
            WirelessPkgLen: '',
            channel: '',
            id: '',
            sn: ''
          }
        ]
      }
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      fetch.getLockInfo({ id: this.data }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.actData = data
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    handleCancel() {
      this.$emit('handleClose')
    }
  }
}
</script>

<style></style>
